module.exports = __webpack_public_path__ + "static/media/walmart.5784116b.jpg";